import SettingService from "../../service/SettingService";
//import swal from 'sweetalert'

export const namespaced = true

export const state = {
    settingLoading: true,
    createLoading: false,
    apiKeys:{
        apikeyID: '',
        apikeyCustomerID: '',
        apikeyAccountNumber: '',
        apikeyTestSK: '',
        apikeyTestPK: '',
        apikeyLiveSK: '',
        apikeyLivePK: '',
        apikeyLiveCallback: '',
        apikeyGroupCode: '',
        apikeyTestCallback: '',
        apikeyTestWebhook: '',
        apikeyLiveWebhook: '',
        responseCode: '',
        responseMessage: ''
    },
    response: {}
}


export const getters = {
}


export const mutations = {
    updateApiKeys: (state, payload) =>{
      state.apiKeys = payload
    },
    updateSettingLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.settingLoading = payload;
    },
    updateCreateLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.createLoading = payload;
    },
    reset: (state, payload) =>{
        state.settingLoading =  false;
        state.apiKeys = payload;
        state.response =  {};
    },
}


export const actions = {
    createFintechCustomer: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateSettingLoading", true)
            return SettingService.callCreateFintechCustomerApi(payload)
            .then(response => {
                commit("updateSettingLoading", false);
                if (response.data.responseCode === "00") {
                    commit("updateApiKeys", response.data);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Api Generated Successfully', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'}
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
                
            })
            .catch(error => {
                commit("updateSettingLoading", false);
                alert(error)
                // throw error;
            });
    },

    updateFintechCustomer: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateSettingLoading", true)
            return SettingService.callUpdateFintechCustomerApi(payload)
            .then(response => {
                commit("updateSettingLoading", false);
                if (response.data.responseCode === "00") {
                    commit("updateApiKeys", response.data);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Api Keys Generated Successfully', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
                
            })
            .catch(error => {
                commit("updateSettingLoading", false)
                alert(error)
                // throw error;
            });
    },

    createFinTechCustomerTest: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateSettingLoading", true)
            return SettingService.callCreateFinTechCustomerTestApi(payload)
            .then(response => {
                commit("updateSettingLoading", false);
                if (response.data.responseCode === "00") {
                    commit("updateApiKeys", response.data);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Api Keys Generated Successfully', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }

            })
            .catch(error => {
                commit("updateSettingLoading", false)
                alert(error)
                // throw error;
            });
    },

    getApiKey: ({ commit }, payload)=>{
        commit("updateSettingLoading", true)
            return SettingService.callGetApiKeysApi(payload)
            .then(response => {
                commit("updateSettingLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateApiKeys", response.data)
                }
            })
            .catch(error => {
                // commit("upadateSettingLoading", false)
                commit("updateApiKeys", null)
                alert(error)
                // throw error;
            });
    },

    saveChanges: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateCreateLoading", true)
            return SettingService.callSaveChangesApiKeyApi(payload)
            .then(response => {
                commit("updateCreateLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateApiKeys", response.data);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Changes Saved Successfully', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
                
            })
            .catch(error => {
                commit("upadateSettingLoading", false)
                alert(error)
                // throw error;
            });
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
